import React from "react";
import { useDynamicFormAttestationText } from "../../context/DynamicFormAttestationContext";
import { IDynamicFieldProps } from "../../types";
import { DynamicFormAttestation } from "../DynamicFormAttestation";

/**
 * Renders a `SignatureBlock` field: the form's attestation copy plus a consent
 * checkbox bound to the field's own key. The boolean value becomes the submit
 * signature's `consentAccepted`.
 */
export const DynamicFieldSignature: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled
}) => {
  const attestationText = useDynamicFormAttestationText();
  return (
    <DynamicFormAttestation
      attestationText={attestationText}
      name={name}
      label={field.label}
      disabled={disabled}
    />
  );
};
